import { Button, Loading } from 'components'
import { useAccountActions } from 'hooks/userHooks'
import { useEffect } from 'react'
import { DeviceType } from 'types'
import { noop } from 'utils'
export type ResendInstructionsBtnProps = {
  userId: string
  device?: DeviceType
  disabled?: boolean
  onDone?: (message: string) => void
  onError?: (message: string) => void
}
export const ResendInstructionsBtn = ({
  disabled = false,
  userId,
  device,
  onDone = noop,
  onError = noop,
}: ResendInstructionsBtnProps) => {
  const [state, { sendInstructions }] = useAccountActions()
  useEffect(() => {
    if (state.matches('success')) {
      onDone('Download instructions sent')
    } else if (state.matches('failed')) {
      onError('Failed sending instructions, please try again')
    }
  }, [state, onDone, onError])
  return (
    <Button
      type="button"
      variant="buttons.outline"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 50,
      }}
      disabled={disabled || state.matches('syncing')}
      onClick={() => sendInstructions({ userId, device })}>
      {state.matches('syncing') ? (
        <Loading />
      ) : (
        <span>Resend download instructions</span>
      )}
    </Button>
  )
}
